export enum Platforms {
    WEB = 'WEB',
    MOBILE = 'MOBILE'
}
